import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { enhanceElementWithClassName, COMPONENT_SIZE_CLASS_MAP, COMPONENT_KIND_CLASS_MAP } from '../../utilities/buttonLinkShared.js';

const buildComponentClassName = ({ className, fullWidth, kind, size, }) => {
    return classNames(kind && "tds-btn", size && size !== "md" && COMPONENT_SIZE_CLASS_MAP[size], kind && COMPONENT_KIND_CLASS_MAP[kind], fullWidth && "tds-btn--full-width", className);
};
const BaseButton = forwardRef(({ size, prefix, suffix, kind = "secondary", label, className, fullWidth, ...restProps }, ref) => {
    const combinedClassName = buildComponentClassName({
        className,
        fullWidth,
        kind,
        size,
    });
    const prefixElement = enhanceElementWithClassName(prefix, "prefix");
    const suffixElement = enhanceElementWithClassName(suffix, "suffix");
    return (React.createElement("button", { type: "button", className: combinedClassName, ref: ref, ...restProps },
        prefixElement,
        label,
        suffixElement));
});
BaseButton.displayName = "BaseButton";

export { BaseButton };
//# sourceMappingURL=BaseButton.js.map
